<template>
  <div :class="['header ellipsis', config.navbarPosition === 'left' ? 'header-left' : '', config.navbarStyle === 'one' ? '' : 'header-two', config.navbarPosition === 'top' ? 'header-list-top' : '']">
    <!-- 当前只走一个，后面要多个再说 -->
    <template v-for="(list, index) in config.children">
      <div v-if="!list.viewShow"
           :key="index"
           @click="setHeader(index)"
           :style="[
              config.columnFontConfig,
              config.selected === index && config.navbarStyle === 'four' ? {
                background: `url('${$imgurl + config.navbarBgImg}') no-repeat`,
                backgroundSize: '100% 100%'
              } : ''
            ]"
           :class="[
            'header-list', 
            config.navbarStyle === 'one' ? '' : config.navbarStyle === 'three' ? 'header-style-three' : 'header-style-two', 
            config.selected === index ? 'active' : '']">
        <icon-module v-if="config.navbarStyle === 'icon'" class="header-img" :config="config.icon" />
        <span>{{ list.name }}</span>
      </div>
    </template>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'
import { defineAsyncComponent } from 'vue';

export default {
  name: "container-header",
  components: {
    IconModule: defineAsyncComponent(() => import('@/components/common/icon/iconModule.vue'))
  },
  data () {
    return {
      newConfig: {}
    }
  },
  props: {
    config: {
      type: Object
    },
    isFrontEnd: {
      type: Boolean
    },
    index: {
      type: Number
    }
  },
  // watch: {
  //   immediate: true,
  //   handler (val) {
      
  //   },
  // },
  methods: {
    setHeader (ind) {
      const _config = cloneDeep(this.config)
      _config.selected = ind
      this.$emit('update:config', _config)
      // 如果是客户端查看模式，给到需要查询的下标（当前指定第一个，目前需求只有一个）
      console.log('客户端读取', !this.isFrontEnd && this.config.children[ind].children[0])
      if (!this.isFrontEnd && this.config.children[ind].children[0]) this.$emit('upSelected', this.config.children[ind].children[0])
    }
  }
}
</script>

<style scoped lang="scss">
.header {
  height: 48px;
  line-height: 48px;
  border-bottom: rgba(28,41,81,1);
  border-bottom: 1px solid #DCDEE0;
  padding-left: 16px;
  padding-right: 16px;
  display: flex;
  align-items: center;
  .header-list {
    padding-left: 25px;
    padding-right: 25px ;
    display: flex;
    align-items: center;
    cursor: pointer;
    position: relative;
    line-height: 22px;
  }
  .header-img {
    width: 21px;
    height: 21px;
    font-size: 21px;
    line-height: 21px;
  }
  .active {
    position: relative;
    font-size: 18px;
    font-weight: 500;
    padding-left: 16px;
    padding-right: 16px;
    &::after {
      width: calc(100% - 32px);
      height: 2px;
      content: ' ';
      position: absolute;
      bottom: -6px;
      left: 16px;
      background-color: #38A2FB;
      border-radius: 2px;
    }
  }
  .header-style-two {
    background-color: #F7F7F7;
    border-top: 1px solid #D0D0D0;
    border-right: 1px solid #D0D0D0;
    line-height: 46px;
    color: #999999;
    &:nth-child(1) {
      margin-left: -16px;
      border-left: 1px solid #D0D0D0;
      border-top-left-radius: 4px;
    }
    &:last-child {
      border-top-right-radius: 4px;
    }
  }
  .header-style-two.active {
    top: 1px;
    background-color: #ffffff;
    &::after {
      //display: none;
      background-color: #ffffff;
      bottom: -1px;
      width: 100%;
      left: 0;
    }
  }
  .header-style-three.active {
    background-color: #4e86ff;
    height: 100%;
    &::after {
      display: none;
    }
    span {
      background-color: #ffffff;
      border-radius: 4px;
      padding: 2px 5px;
    }
  }
}
.header-left.header-two {
  display: inline !important;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    width: 2px;
  }
}
.header-two {
  width: 48px !important;
  min-width: 48px !important;
  display: flex !important;
  overflow: hidden;
  justify-items: start;
  justify-content: flex-start;
  flex-direction: column;
}

.header-left {
  height: 100%;
  display: block;
  padding-left: 0;
  padding-right: 0;
  line-height: 38px;
  border-right: 1px solid #DCDEE0;
  width: 92px;
  min-width: 92px;
  .header-list {
    line-height: 38px;
    padding-left: 18px;
    padding-right: 18px;
    width: calc(100% - 23px);
    color: #999999;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .active {
    padding-left: 14px;
    padding-right: 9px;
    background-color: #B9D9FD;
    color: #333333;
    &::after {
      left: 0;
      top: 12px;
      width: 3px;
      height: 18px;
    }
  }
  .header-style-two {
    width: 14px;
    line-height: 22px;
    overflow: inherit;
    white-space: inherit;
    border-left: 1px solid #D0D0D0;
    padding: 15px 16px 15px 17px;
    writing-mode: vertical-rl;
    text-orientation: upright;
    // height: 100%;
    //margin-top: -10px;
    &:nth-child(1) {
      margin-left: 0;
      border-top-left-radius: 4px;
    }
    &:last-child {
      border-top-right-radius: 4px;
      border-bottom: 1px solid #D0D0D0;
    }
  }
  .header-style-two.active {
    width: 24px;
    padding-left: 14px;
    padding-right: 9px;
    &::after {
      display: none;
    }
    &:last-child {
      border-bottom-left-radius: 4px;
      border-bottom: 1px solid #D0D0D0;
    }
  }
}
.header-list-top {
  width: calc(100% - 32px) !important;
  min-width: calc(100% - 32px) !important;
  flex-direction: initial !important;
  overflow-x: auto !important;
  overflow-y: hidden !important;
  // overflow: inherit !important;
}
</style>
